import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { AuthenticationService } from './../../core/authentication/authentication.service';
import { Logger } from './../../core/logger.service';
import { ModalService } from 'app/modal/modal.service';
import * as Models from 'app/core/models';
import {TranslateService} from '@ngx-translate/core';
import {ISignupResult} from './signupResult.model';
import { SignupAction } from './signup.enum';

const log = new Logger('App');
@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})

export class SignupComponent  {

    @Input('inModal') inModal = false;
    @Output('successHandler') successHandler: EventEmitter<ISignupResult> = new EventEmitter<ISignupResult>();
    @Output('failiureHandler') failiureHandler: EventEmitter<ISignupResult> = new EventEmitter<ISignupResult>();

    version: string = environment.version;
    error: any = null;
    signupForm: FormGroup;
    isLoading = false;
    showForm = true;
    showSuccessMessage = false;

    constructor(private formBuilder: FormBuilder,
                private authenticationService: AuthenticationService,
                private modalService: ModalService,
                private translateService: TranslateService) {
        this.createForm();
    }

    reset() {
        this.signupForm.reset();
        this.showSuccessMessage = false;
        this.error = null;
        this.showForm = true;
    }

    signUp() {
        this.isLoading = true;
        this.authenticationService.signup(this.signupForm.value)
            .finally(() => {
                if (!this.error) {
                    this.signupForm.markAsPristine();
                    this.signupForm.reset();
                    this.sucessAction();
                }
                this.isLoading = false;
            })
            .subscribe(credentials => {
                log.debug(`successfully signed up`);
                this.error = undefined;
                this.showForm = false;
                this.showSuccessMessage = true;
            }, error => {
                log.debug(`Signup error: ${error}`);
                this.error = error;
            });
    }

    sucessAction() {
        this.successHandler.next({ action: SignupAction.POSITIVE });
    }

    login() {
        const data: Models.ModalContext = {
            modalType: Models.ModalType.LOGIN,
            modalAction: Models.ModalAction.OPEN,
            parameters: []
        };
        this.modalService.command(data);
    }

    close() {
        const data: Models.ModalContext = {
            modalType: Models.ModalType.SIGN_UP,
            modalAction: Models.ModalAction.CLOSE,
            parameters: []
        };
        this.modalService.command(data);
    }

    private createForm() {
        this.signupForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', Validators.email],
            password: ['', Validators.minLength(6)]
        });
    }

    get errorMessage(): string {
        if (this.error) {
            const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
            if (errorBody && errorBody.error) {
              return errorBody.error;
            }
        }
      this.translateService.get('AUTH.SIGN_UP.GENERAL_ERROR').subscribe((translatedErrMsg: string) => {
        return translatedErrMsg
      });
    }
}





// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/signup/signup.component.ts